module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/45d490462c846e04081f2024ba2d8e15.png";